const ProgramCategoryEnum = Object.freeze({
    COMPREHENSIVE_PROGRAM: { value: 'comprehensive', text: 'Comprehensive program' },
    THEMATIC_PROGRAM: { value: 'thematic', text: 'Thematic program' },
});

export default ProgramCategoryEnum;
